import { select } from 'd3c';
import i18n from 'localize';

const sliderTooltip = function(Tooltip, legend) {
	const modulIds = [`legendTooltip_${legend.id}`];
	const sliderWidget = Tooltip.createWidget(modulIds, i18n.t9n('Scaling'), Tooltip.WidgetTypes.SLIDER, null, false);

	// DATA SETTINGS
	sliderWidget
		.setBoundaries(0.5, 1.5)
		.setValue(legend.scaling())
		.setCallback(function(value) {
			legend.scaling(value);
		}, true);

	Tooltip.setHideCallback(modulIds, function() {
		select(`#${legend.id}`).classed('clicked', false);
	});

	return {
		getTooltipData(d) {
			return {
				modulIds,
				title: '',
				data: d
			};
		},
		widgets() {
			return {
				scaling: sliderWidget
			};
		}
	};
};

const bubblelegendTooltip = function(id, module, callback, tooltipClasses, tooltipHeight) {
	const defaultTooltipClasses = 'forceWidth110';
	let tooltip = null;
	let nodeSizeFactor = 1;
	const legend = {
		id,
		initialized: false
	};

	legend.initTooltip = function(Tooltip) {
		tooltip = sliderTooltip(Tooltip, legend);
	};

	legend.getTooltipWidgets = function() {
		return tooltip.widgets();
	};

	legend.scaling = function(_) {
		if (!arguments.length) {
			return nodeSizeFactor;
		}

		nodeSizeFactor = _;

		if (callback) {
			callback(nodeSizeFactor);
		}

		return legend;
	};

	legend.getTooltipData = function() {
		return tooltip.getTooltipData();
	};

	legend.bubbleLegendClicked = function(event, element) {
		select(element).classed('clicked', true);
		return {
			data: {
				specific: 'legend'
			},
			fix: true,
			tooltipClasses: tooltipClasses !== undefined ? tooltipClasses : defaultTooltipClasses,
			x: event.pageX,
			y: event.pageY - (tooltipHeight ? tooltipHeight : 55),
			hideCallback() {
				select(element).classed('clicked', false);
			}
		};
	};

	return legend;
};

export { sliderTooltip, bubblelegendTooltip };
